import { NaturalNumber_Schema } from "@/utilities";
import { z } from "zod";

export const UserBankInfoId_Schema = NaturalNumber_Schema;

export const UserBankInfo_Schema = z.object({
  id: UserBankInfoId_Schema,
  accountNumber: z.string().nullable(), // "002-001223/0700"

  // There is more properties however we do not use them.
  // Therefore do not use strict().
  // Feel free to define them if needed.
});
